<template>
    <div>
        <table v-show="acquired" class="table is-hoverable is-narrow is-centered">
            <thead class="is-size-5">
                <tr>
                <th><abbr class="is-size-6" title="Scenario">Cumulative</abbr></th>
                <th>{{ this.today | moment("MMM") }}</th>
                <th>{{ this.today | moment("add", "1 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "2 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "3 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "4 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "5 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "6 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "7 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "8 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "9 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "10 month", "MMM") }}</th>
                <th>{{ this.today | moment("add", "11 month", "MMM") }}</th>
                </tr>
            </thead>
            <!-- <tfoot>
                <tr>
                <th><abbr title="Scenario">Scenario</abbr></th>
                <th>Month 1</th>
                <th>Month 2</th>
                <th>Month 3</th>
                <th>Month 4</th>
                <th>Month 5</th>
                <th>Month 6</th>
                <th>Month 7</th>
                <th>Month 8</th>
                <th>Month 9</th>
                <th>Month 10</th>
                <th>Month 11</th>
                <th>Month 12</th>
                </tr>
            </tfoot> -->
            <tbody class="is-size-7">
                <tr>
                <td class="is-size-6">Revenue</td>
                <td> {{ formatNumber(acquired * dealSize * 1) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 2) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 3) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 4) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 5) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 6) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 7) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 8) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 9) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 10) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 11) }} </td>
                <td> {{ formatNumber(acquired * dealSize * 12) }} </td>
                </tr>
                <tr>
                <td class="is-size-6">Profit</td>
                <td> {{ formatNumber(profit * 1) }} </td>
                <td> {{ formatNumber(profit * 2) }} </td>
                <td> {{ formatNumber(profit * 3) }} </td>
                <td> {{ formatNumber(profit * 4) }} </td>
                <td> {{ formatNumber(profit * 5) }} </td>
                <td> {{ formatNumber(profit * 6) }} </td>
                <td> {{ formatNumber(profit * 7) }} </td>
                <td> {{ formatNumber(profit * 8) }} </td>
                <td> {{ formatNumber(profit * 9) }} </td>
                <td> {{ formatNumber(profit * 10) }} </td>
                <td> {{ formatNumber(profit * 11) }} </td>
                <td> {{ formatNumber(profit * 12) }} </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
var moment = require('moment')

export default {
	props: ['today', 'acquired', 'dealSize', 'profit'],
	methods: {
		formatNumber (num) {
			num = Math.round(num)
			return "£" + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
		}
	}
}
</script>
